const comments = [
  {
    id: 1,
    name: '漫画迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20of%20a%20young%20person%20with%20warm%20tones%2C%20simple%20circular%20frame%2C%20soft%20colors%2C%20minimal%20design&width=80&height=80&seq=avatar-comment-01&orientation=squarish',
    text: '羞羞漫画真的太良心了！韩漫日漫资源超全，每天蹲点等更新，下拉式阅读体验丝滑到不行，完全停不下来！',
    manga: '《霸道总裁的契约新娘》',
    time: '2小时前',
  },
  {
    id: 2,
    name: '追更狂人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20avatar%20portrait%20of%20a%20young%20male%20with%20warm%20coral%20tones%2C%20simple%20circular%20frame%2C%20soft%20colors%2C%20minimal%20design&width=80&height=80&seq=avatar-comment-02&orientation=squarish',
    text: '国漫专区做得太好了，斗破乾坤系列一直在追，更新速度比别家快多了，而且完全免费，推荐给所有漫友！',
    manga: '《斗破乾坤之逆天改命》',
    time: '5小时前',
  },
  {
    id: 3,
    name: '深夜读书人',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20anime%20style%20avatar%20portrait%20of%20a%20young%20female%20with%20warm%20cream%20tones%2C%20simple%20circular%20frame%2C%20soft%20colors%2C%20minimal%20design&width=80&height=80&seq=avatar-comment-03&orientation=squarish',
    text: '从追韩漫开始入了羞羞漫画的坑，现在日漫国漫全都在这里看。界面清爽没有乱七八糟的广告，阅读体验满分！',
    manga: '《我的女友是九尾狐》',
    time: '昨天',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
            <i className="ri-chat-heart-line text-accent-500 text-xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">读者热评</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-[52px]">来自真实读者的走心评价</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {comments.map((comment) => (
            <div key={comment.id} className="p-6 rounded-2xl bg-background-100 border border-background-200/70 hover:border-accent-200 transition-all duration-200 cursor-pointer">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-800">{comment.name}</h3>
                  <span className="text-xs text-foreground-500">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.text}</p>
              <span className="inline-flex items-center gap-1.5 text-xs text-accent-600 bg-accent-50 px-3 py-1 rounded-full">
                <i className="ri-bookmark-line"></i>
                {comment.manga}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}